import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import { FcGoogle } from 'react-icons/fc';

import { clientStore } from 'apps/client/app';
import { conf } from 'apps/signIn/config.yaml';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';
import { isMobile } from 'styles/utils';

import {
  MainWrapperSocialButtons,
  WrapperSocialButton,
} from 'apps/signIn/styles';

@withNamespaces()
@observer
export class SocialButtons extends React.Component {
  render() {
    const { t, prefix } = this.props;
    // const nextParam = clientStore.routerStore.params.get('next');
    const nextParam = clientStore.next();
    const nextPath = nextParam ? `?next=${nextParam}` : '';

    const keysList = Object.keys(conf.social);
    const buttons = keysList.map(key => {
      const item = conf.social[key];

      let HMACParam = '';
      if (!clientStore.signedInProfile && clientStore.HMAC) {
        let appendSymbol = '?';
        if (nextPath) appendSymbol = '&';
        HMACParam = `${appendSymbol}hmac=${clientStore.HMAC}`;
      }
      const href = `${MAIN_URL}${item.link}${nextPath}${HMACParam}`;
      const googleIcon = key === 'google';
      const showTitle = `${prefix || 'Log in'} ${item.title}`;

      return (
        <WrapperSocialButton key={item.icon}>
          {googleIcon ? (
            <a
              href={href}
              className='flex items-center text-black rounded-full h-full border p-2 border-gray-400 text-sm'
            >
              <FcGoogle size={26} />
              {!isMobile() && <p className='mx-1'>{t(showTitle)}</p>}
            </a>
          ) : (
            <Button
              as='a'
              text={key === 'google' ? showTitle : ''}
              outline
              variant='minimal'
              icon={item.icon}
              href={href}
              data-for='signInTip'
              data-tip={t(showTitle)}
              customColor='black'
            />
          )}
        </WrapperSocialButton>
      );
    });

    return (
      <>
        <Tooltip id='signInTip' delayShow={500} />
        <MainWrapperSocialButtons>{buttons}</MainWrapperSocialButtons>
      </>
    );
  }
}

SocialButtons.propTypes = {
  t: PropTypes.func,
  prefix: PropTypes.string,
};
